export const EventsEmptyStateIcon = () => {
  return (
    <svg
      width={`100%`}
      height={`100%`}
      // height="244"
      viewBox="0 0 413 244"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="55.646"
        width="137"
        height="215"
        rx="18"
        transform="rotate(15 55.646 0)"
        fill="url(#paint0_linear_1624_23273)"
      />
      <path
        d="M120.878 129.809L100.743 143.819C96.8166 146.594 91.8585 147.479 87.2133 146.234C82.5681 144.989 78.7169 141.744 76.7024 137.377L66.791 115.821C65.0119 111.974 64.7548 107.596 66.0671 103.567C67.3811 99.5369 70.1689 96.1529 73.8737 94.0938C77.842 92.0136 82.4972 91.6854 86.7158 93.1876C90.962 94.6639 94.3838 97.87 96.1332 102.011L98.2137 106.474L101.635 104.051C105.037 101.525 109.272 100.383 113.483 100.856C117.694 101.331 121.569 103.384 124.324 106.603C126.947 110.141 128.027 114.589 127.32 118.935C126.748 123.288 124.42 127.217 120.878 129.809L120.878 129.809Z"
        fill="white"
      />
      <rect
        x="137.978"
        y="14.0662"
        width="137"
        height="215"
        rx="18"
        fill="url(#paint1_linear_1624_23273)"
      />
      <path
        d="M234.584 122.569L218.762 141.313C215.687 145.009 211.127 147.147 206.318 147.147C201.509 147.147 196.949 145.009 193.873 141.313L178.72 123.056C176.006 119.801 174.625 115.638 174.849 111.407C175.076 107.174 176.893 103.184 179.938 100.236C183.233 97.1999 187.644 95.678 192.108 96.0371C196.592 96.3641 200.727 98.5754 203.488 102.122L206.653 105.895L209.33 102.669C211.963 99.3487 215.758 97.1498 219.948 96.5169C224.138 95.8857 228.413 96.8653 231.907 99.2614C235.356 102 237.551 106.018 237.992 110.399C238.567 114.751 237.335 119.149 234.585 122.569H234.584Z"
        fill="white"
      />
      <rect
        x="224.978"
        y="35.4583"
        width="137"
        height="215"
        rx="18"
        transform="rotate(-15 224.978 35.4583)"
        fill="url(#paint2_linear_1624_23273)"
      />
      <path
        d="M346.374 115.26L335.943 137.46C333.93 141.827 330.078 145.072 325.433 146.317C320.788 147.561 315.83 146.677 311.902 143.902L292.54 130.189C289.076 127.748 286.664 124.085 285.786 119.939C284.909 115.792 285.632 111.468 287.81 107.832C290.207 104.046 294.074 101.434 298.479 100.626C302.894 99.7815 307.461 100.847 311.046 103.558L315.08 106.384L316.831 102.575C318.515 98.6859 321.611 95.5799 325.494 93.884C329.378 92.1898 333.761 92.0297 337.756 93.4397C341.797 95.1922 344.956 98.505 346.517 102.622C348.198 106.678 348.147 111.244 346.375 115.26L346.374 115.26Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1624_23273"
          x1="124.146"
          y1="0"
          x2="233.255"
          y2="50.4683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37645D" />
          <stop offset="1" stopColor="#1F5C53" stop-opacity="0.38" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1624_23273"
          x1="206.478"
          y1="14.0662"
          x2="315.587"
          y2="64.5345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#11473F" />
          <stop offset="1" stopColor="#1F5C53" stop-opacity="0.38" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1624_23273"
          x1="293.478"
          y1="35.4583"
          x2="402.587"
          y2="85.9266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37645D" />
          <stop offset="1" stopColor="#1F5C53" stop-opacity="0.38" />
        </linearGradient>
      </defs>
    </svg>
  );
};
